import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group'

export type Weekday = { value: number; label: string; weekend?: boolean }

export function WeekdaySegment({
  value,
  onChange,
  days,
  ariaLabel,
}: {
  value: number
  onChange: (value: number) => void
  days: readonly Weekday[]
  ariaLabel?: string
}) {
  const index = Math.max(
    0,
    days.findIndex((day) => day.value === value),
  )
  return (
    <div className="relative flex h-field rounded-nested border border-segment bg-segment p-[3px]">
      <span
        aria-hidden
        className="pointer-events-none absolute inset-y-[3px] rounded-chip bg-segment-thumb shadow-segment transition-[left] duration-thumb ease-sheet"
        style={{
          width: `calc((100% - 6px) / ${days.length})`,
          left: `calc(3px + (100% - 6px) / ${days.length} * ${index})`,
        }}
      />
      <ToggleGroupPrimitive.Root
        type="single"
        value={String(value)}
        onValueChange={(next: string) => {
          if (next) onChange(Number(next))
        }}
        aria-label={ariaLabel}
        className="relative z-1 flex w-full"
      >
        {days.map((day) => (
          <ToggleGroupPrimitive.Item
            key={day.value}
            value={String(day.value)}
            className={`pressable flex flex-1 items-center justify-center rounded-chip text-list leading-none transition-colors duration-row ${
              day.value === value
                ? 'font-medium text-text'
                : `font-normal ${day.weekend ? 'text-text-muted' : 'text-text-secondary'}`
            }`}
          >
            {day.label}
          </ToggleGroupPrimitive.Item>
        ))}
      </ToggleGroupPrimitive.Root>
    </div>
  )
}
